import { ROUTES } from "../../../config/routes";

/**
 * Configuration per route
 * Each property in this object should correspond to a route path, this property will be of type `Object`
 * This object can contain these configuration:
 *
 * @param {String} name Page name
 * @param {String} type Page type category (i.e: summary)
 * @param {String} section Site section to which the page is part of
 */

export const PAGE_DATA = {
  [ROUTES.HOME]: {
    name: "Card details",
    type: "PAGE",
    section: "CARD_DETAILS_PAGE",
  },
  [ROUTES.DISPLAY_CARD]: {
    name: "Display Card",
    type: "PAGE",
    section: "DISPLAY_CARD_PAGE",
  },
  [ROUTES.ERROR_PAGE]: {
    name: "Error page",
    type: "PAGE",
    section: "ERROR_PAGE",
  },
  [ROUTES.TIMEOUT]: {
    name: "Timeout page",
    type: "PAGE",
    section: "TIMEOUT_PAGE",
  },
  [ROUTES.CONFIRMATION]: {
    name: "Confirmation Page",
    type: "PAGE",
    section: "CONFIRMATION_PAGE",
  },
};
